/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnitAllOfReservationPayments
 */
export interface UnitAllOfReservationPayments {
    /**
     * 
     * @type {number}
     * @memberof UnitAllOfReservationPayments
     */
    amount: number;
    /**
     * 
     * @type {Date}
     * @memberof UnitAllOfReservationPayments
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof UnitAllOfReservationPayments
     */
    description?: string;
}

/**
 * Check if a given object implements the UnitAllOfReservationPayments interface.
 */
export function instanceOfUnitAllOfReservationPayments(value: object): value is UnitAllOfReservationPayments {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function UnitAllOfReservationPaymentsFromJSON(json: any): UnitAllOfReservationPayments {
    return UnitAllOfReservationPaymentsFromJSONTyped(json, false);
}

export function UnitAllOfReservationPaymentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitAllOfReservationPayments {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'date': (new Date(json['date'])),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UnitAllOfReservationPaymentsToJSON(json: any): UnitAllOfReservationPayments {
    return UnitAllOfReservationPaymentsToJSONTyped(json, false);
}

export function UnitAllOfReservationPaymentsToJSONTyped(value?: UnitAllOfReservationPayments | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'date': ((value['date']).toISOString()),
        'description': value['description'],
    };
}

